import type { VoidCallback } from '../components';
import { createStore } from './Store';

/**
 * This tracks the number of currently active AJAX requests.
 *
 * Do not use this unless you know how it works. You have been warned!
 *
 * It should normally not be needed, but it's there in case some places need to prevent something **while any ajax request on the page is active**.
 * ExtJS's Sense.Ajax also updates this store if it's on the page.
 *
 * @author Bennett Piater
 */
export interface AjaxRequestStore {
  /** The number of active requests ANYWHERE, I mean ANYWHERE, on the page. */
  active: number;
  /** Function to increment the counter */
  increment: VoidCallback;
  /** Function to decrement the counter */
  decrement: VoidCallback;
}

export const [
  useAjaxRequestStore,
  AjaxRequestStoreApi
] = createStore<AjaxRequestStore>('EhsReact::AjaxRequestStore', set => ({
  active: 0,

  increment: () => set(state => ({ active: state.active + 1 }), 'increment'),

  decrement: () => set(state => ({ active: state.active - 1 }), 'decrement')
}));

/**
 * Returns whether any ajax request is currently in flight anywhere in the page.
 *
 * Do not use this unless you know how it works. You have been warned!
 *
 * @author Bennett Piater
 */
export function useIsAjaxInFlight(): boolean {
  return useAjaxRequestStore(state => state.active > 0);
}
